import { StateService } from '@uirouter/angularjs';

export function uiRouterErrorHandlerRunConfig( $state: StateService ) {
  $state.defaultErrorHandler(( err: any ) => {
    console.log(err);
  });
}

uiRouterErrorHandlerRunConfig.$inject = [ '$state' ];



// WEBPACK FOOTER //
// ./app/run/uirouter-error-handler.ts